import React, { useMemo } from 'react';
import type { RouteOperationalProcessesPayload } from '../../operationalDomain/processes/operationalProcessTypes';
import { pickComplianceSummary } from '../../operationalDomain/compliance/complianceTypes';

export type ExecutionComplianceStripProps = {
  payload: RouteOperationalProcessesPayload | null | undefined;
};

const ExecutionComplianceStrip: React.FC<ExecutionComplianceStripProps> = ({ payload }) => {
  const summary = useMemo(
    () => pickComplianceSummary(payload?.decisionSupport?.compliance ?? null),
    [payload?.decisionSupport?.compliance]
  );

  const topViolation = useMemo(
    () => payload?.decisionSupport?.compliance?.violations?.[0] ?? null,
    [payload?.decisionSupport?.compliance?.violations]
  );

  if (!summary) return null;

  return (
    <section className="execution-workspace__panel execution-workspace__panel--compliance">
      <div className="execution-workspace__panel-title">Соответствие и исправления</div>
      <ul className="execution-compliance-summary">
        {summary.openRemediations > 0 ? (
          <li>{summary.openRemediations} открытых исправлений</li>
        ) : null}
        {summary.criticalViolations > 0 ? (
          <li className="execution-compliance-summary__critical">
            {summary.criticalViolations} критических нарушений
          </li>
        ) : null}
        {summary.pendingCorrectiveActions > 0 ? (
          <li>{summary.pendingCorrectiveActions} корректирующих действий</li>
        ) : null}
      </ul>
      {topViolation ? (
        <div className="execution-compliance-summary__detail">{topViolation.message}</div>
      ) : null}
    </section>
  );
};

export default ExecutionComplianceStrip;
